module.exports = __webpack_public_path__ + "static/media/shoulders1Right.9d6ef8a5.png";